export var BudgetInclude = {
    organization: true,
    locations: { include: { businessUnit: true } },
    products: { include: { businessUnit: true } },
    businessUnit: true,
    unit: true,
};
//# sourceMappingURL=Budget.js.map